import { render, staticRenderFns } from "./recipients-overview-stats.vue?vue&type=template&id=40d401f8&scoped=true&"
import script from "./recipients-overview-stats.vue?vue&type=script&lang=js&"
export * from "./recipients-overview-stats.vue?vue&type=script&lang=js&"
import style0 from "./recipients-overview-stats.vue?vue&type=style&index=0&id=40d401f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d401f8",
  null
  
)

export default component.exports